import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Check } from "lucide-react";

const barColor = ["#16233d", "#b08d57", "#c9b28a"];

export default function Strategies({ onContact }) {
  const strategies = useContent().strategies;
  return (
    <section className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl reveal">
          <div className="eyebrow mb-4">{strategies.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{strategies.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{strategies.text}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {strategies.items.map((s) => (
            <div
              key={s.name}
              className={`relative card-lift rounded-2xl p-8 border ${
                s.popular ? "bg-white border-[#b08d57] shadow-[0_20px_50px_-24px_rgba(176,141,87,0.5)]" : "bg-white border-[#efe9dd]"
              }`}
            >
              {s.popular && (
                <span className="absolute -top-3 left-8 bg-[#b08d57] text-white text-xs font-semibold px-3 py-1 rounded-full tracking-wide">
                  {strategies.popular}
                </span>
              )}
              <h3 className="font-serif-lux text-3xl text-[#16233d]">{s.name}</h3>
              <div className="mt-4">
                <div className="text-xs uppercase tracking-wide text-[#8a8f9c]">{strategies.expectedReturn}</div>
                <div className="font-serif-lux text-4xl text-[#b08d57] mt-1">{s.ret}</div>
              </div>
              <div className="mt-3 flex items-center gap-2 text-sm">
                <span className="text-[#8a8f9c]">{strategies.risk}</span>
                <span className="font-medium text-[#16233d]">{s.risk}</span>
              </div>
              <p className="mt-4 text-[#5c6577] text-sm leading-relaxed">{s.text}</p>

              <div className="mt-6">
                <div className="text-xs uppercase tracking-wide text-[#8a8f9c] mb-3">{strategies.allocation}</div>
                <div className="space-y-3">
                  {s.alloc.map((a, idx) => (
                    <div key={a.k}>
                      <div className="flex justify-between text-sm mb-1">
                        <span className="text-[#3a4258]">{a.k}</span>
                        <span className="font-medium text-[#16233d]">{a.v}%</span>
                      </div>
                      <div className="h-2 rounded-full bg-[#f0ece3] overflow-hidden">
                        <div className="h-full rounded-full" style={{ width: `${a.v}%`, background: barColor[idx] }} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={onContact}
                className={`mt-7 w-full rounded-md py-3 text-sm font-medium transition-all ${
                  s.popular ? "btn-gold" : "btn-outline-navy"
                }`}
              >
                {strategies.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
